module.exports = __webpack_public_path__ + "img/amex-stacked.d28c3b8f.svg";